/**
 * Represents the mode options for the **Modal** subcomponent.
 */
export var ModalMode;
(function (ModalMode) {
    /**
     * In auto mode, the modal will toggle between full screen and overlay mode based on the screen size.
     */
    ModalMode["Auto"] = "Auto";
    /**
     * In full screen mode, the modal will take over the entire screen.
     */
    ModalMode["FullScreen"] = "FullScreen";
    /**
     * In overlay mode, the modal will appear as an overlay with a darkened background covering the page content.
     */
    ModalMode["Overlay"] = "Overlay";
})(ModalMode || (ModalMode = {}));
